import { render, staticRenderFns } from "./exhibition-register-admin.vue?vue&type=template&id=c78f276c&scoped=true&"
import script from "./exhibition-register-admin.vue?vue&type=script&lang=js&"
export * from "./exhibition-register-admin.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-register-admin.vue?vue&type=style&index=0&id=c78f276c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78f276c",
  null
  
)

export default component.exports